import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import track from 'react-tracking'

import Loader from 'components/common/Loader'
import PreClass from 'components/PreClass'
import ClassRoom from 'components/PreClass/ClassRoom'
import { MOOD } from 'components/Tiles/Modes/Greetings/constants'
import { checklistStatusTypes } from 'constants/checklist'
import { roomConnectionStates } from 'constants/room'
import { classStore, getRoomName } from 'helpers/room'
import useRoomState from 'hooks/useRoomState/useRoomState'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import {
    dispatchSendSocketMessage,
    dispatchSetIsInteractionMode,
} from 'store/dispatcher'
import { _checklistStatus } from 'store/selectors/Checklist'
import { _twilioToken } from 'store/selectors/Room'
import { logger } from 'utils/logger'

const { CONNECTED, RECONNECTING, DISCONNECTED } = roomConnectionStates

const roomName = getRoomName()

const MeetsClass = () => {
    const roomState = useRoomState()
    const status = useSelector(_checklistStatus)
    const twilioToken = useSelector(_twilioToken)
    const skipPreClassChecks = status === checklistStatusTypes.SKIP
    const userDisconnectedCall =
        roomState === DISCONNECTED && classStore.get() === 'off'
    const { connect } = useVideoContext()

    useEffect(() => {
        /* if skip=checklist hook is used
           don't render the PreClass component
           directly connect Room from here
        */
        if (!skipPreClassChecks) return
        ;(async () => {
            try {
                dispatchSetIsInteractionMode(MOOD.NORMAL)
                await connect(twilioToken, {
                    name: roomName,
                    region: 'in1',
                })
                classStore.set('on')
            } catch (error) {
                logger.error(error)
            }
        })()
    }, [skipPreClassChecks])

    if ([CONNECTED, RECONNECTING].includes(roomState))
        return <ClassRoom roomState={roomState} />

    if (skipPreClassChecks || userDisconnectedCall) return <Loader overlay />

    return <PreClass />
}

MeetsClass.propTypes = {}

export default track(
    { app: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}` },
    {
        dispatch: data => {
            ;(window.dataLayer = window.dataLayer || []).push(data)
            logger.event(data)
            setTimeout(() => {
                dispatchSendSocketMessage({
                    action: data.action,
                })
            }, 500)
        },
    }
)(MeetsClass)
